<!--
  This example requires Tailwind CSS v2.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
      require('@tailwindcss/aspect-ratio'),
    ],
  }
  ```
-->
<template>
    <div class="bg-white">
        <div class="mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
            <!-- Product -->
            <div class="lg:grid lg:grid-rows-1 lg:grid-cols-7 lg:gap-x-8 lg:gap-y-10 xl:gap-x-16">
                <!-- Product image -->
                <div class="lg:row-end-1 lg:col-span-4">
<!--                    <div class="aspect-w-4 aspect-h-3 rounded-lg bg-gray-100 overflow-hidden">-->
<!--                        <img :src="product.imageSrc" :alt="product.imageAlt" class="object-center object-cover" />-->
<!--                    </div>-->
                    <div
                        class="rounded-lg overflow-hidden aspect-w-1 aspect-h-1 group-hover:opacity-75 bg-contain bg-no-repeat bg-center"
                        :style="`background-image: url(${product.imageSrc})`"></div>
                </div>

                <!-- Product details -->
                <div class="max-w-2xl mx-auto mt-14 sm:mt-16 lg:max-w-none lg:mt-0 lg:row-end-2 lg:row-span-2 lg:col-span-3">
                    <div class="flex flex-col-reverse">
                        <div class="mt-4">
                            <h1 class="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">{{ product.name }}</h1>

                            <h2 id="information-heading" class="sr-only">Product information</h2>
                            <p>
                                <span class="text-sm text-gray-500 mt-2">EAN: {{product.ean}}</span>
                            </p>
                            <p v-if="product.updatedAt" class="text-xs text-gray-500">
                                Aktualizacja {{ product.updatedAt }}
                            </p>

                        </div>

                        <div>
                            <h3 class="sr-only">Reviews</h3>
                            <div class="flex items-center">
                                <StarIcon v-for="rating in [0, 1, 2, 3, 4]" :key="rating" :class="[reviews.average > rating ? 'text-yellow-400' : 'text-gray-300', 'h-5 w-5 flex-shrink-0']" aria-hidden="true" />
                            </div>
                            <p class="sr-only">{{ reviews.average }} out of 5 stars</p>
                        </div>
                    </div>

                    <p class="text-gray-500 mt-6" v-html="product.description"></p>

                    <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
                        <a :href="product.online_shop_href">
                        <button type="button" class="w-full bg-indigo-600 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500">Kup online</button>
                        </a>

                        <button type="button" class="w-full bg-indigo-50 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-indigo-700 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500">Zapytaj o produkt</button>
                    </div>

                    <div v-if="product.specification" class="border-t border-gray-200 mt-10 pt-10">
                        <h3 class="text-sm font-medium text-gray-900">Specyfikacja</h3>
                        <div class="mt-4 prose prose-sm text-gray-500" v-html="product.specification"></div>
                    </div>

                    <div class="border-t border-gray-200 mt-10 pt-10">
                        <h3 class="text-sm font-medium text-gray-900">Warunki zakupu</h3>
                        <p class="mt-4 text-sm text-gray-500">{{ license.summary }} <a :href="license.href" class="font-medium text-indigo-600 hover:text-indigo-500">Więcej informacji</a></p>
                    </div>

                    <div class="border-t border-gray-200 mt-10 pt-10">
                        <h3 class="text-sm font-medium text-gray-900">Udostępnij</h3>
                        <ul role="list" class="flex items-center space-x-6 mt-4">
                            <li>
                                <a href="#" class="flex items-center justify-center w-6 h-6 text-gray-400 hover:text-gray-500">
                                    <span class="sr-only">Share on Facebook</span>
                                    <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clip-rule="evenodd" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="flex items-center justify-center w-6 h-6 text-gray-400 hover:text-gray-500">
                                    <span class="sr-only">Share on Instagram</span>
                                    <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="#" class="flex items-center justify-center w-6 h-6 text-gray-400 hover:text-gray-500">
                                    <span class="sr-only">Share on Twitter</span>
                                    <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="w-full max-w-2xl mx-auto mt-16 lg:max-w-none lg:mt-0 lg:col-span-4">
                    <TabGroup as="div">
                        <div class="border-b border-gray-200">
                            <TabList class="-mb-px flex space-x-8">
                                <Tab as="template" v-slot="{ selected }">
                                    <button :class="[selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-700 hover:text-gray-800 hover:border-gray-300', 'whitespace-nowrap py-6 border-b-2 font-medium text-sm']">Opinie</button>
                                </Tab>
                                <Tab as="template" v-slot="{ selected }">
                                    <button :class="[selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-700 hover:text-gray-800 hover:border-gray-300', 'whitespace-nowrap py-6 border-b-2 font-medium text-sm']">FAQ</button>
                                </Tab>
                                <Tab as="template" v-slot="{ selected }">
                                    <button :class="[selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-700 hover:text-gray-800 hover:border-gray-300', 'whitespace-nowrap py-6 border-b-2 font-medium text-sm']">Warunki zakupu</button>
                                </Tab>
                            </TabList>
                        </div>
                        <TabPanels as="template">
                            <TabPanel class="-mb-10">
                                <h3 class="sr-only">Opinie</h3>

                                <div v-for="(review, reviewIdx) in reviews.featured" :key="review.id" class="flex text-sm text-gray-500 space-x-4">
                                    <div class="flex-none py-10">
                                        <img :src="review.avatarSrc" alt="" class="w-10 h-10 bg-gray-100 rounded-full" />
                                    </div>
                                    <div :class="[reviewIdx === 0 ? '' : 'border-t border-gray-200', 'py-10']">
                                        <h3 class="font-medium text-gray-900">{{ review.author }}</h3>
                                        <p>
                                            <time :datetime="review.datetime">{{ review.date }}</time>
                                        </p>

                                        <div class="flex items-center mt-4">
                                            <StarIcon v-for="rating in [0, 1, 2, 3, 4]" :key="rating" :class="[review.rating > rating ? 'text-yellow-400' : 'text-gray-300', 'h-5 w-5 flex-shrink-0']" aria-hidden="true" />
                                        </div>
                                        <p class="sr-only">{{ review.rating }} out of 5 stars</p>

                                        <div class="mt-4 prose prose-sm max-w-none text-gray-500" v-html="review.content" />
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel as="dl" class="text-sm text-gray-500">
                                <h3 class="sr-only">Frequently Asked Questions</h3>

                                <template v-for="faq in faqs" :key="faq.question">
                                    <dt class="mt-10 font-medium text-gray-900">{{ faq.question }}</dt>
                                    <dd class="mt-2 prose prose-sm max-w-none text-gray-500">
                                        <p>{{ faq.answer }}</p>
                                    </dd>
                                </template>
                            </TabPanel>

                            <TabPanel class="pt-10">
                                <h3 class="sr-only">Warunki zakupu</h3>

                                <div class="prose prose-sm max-w-none text-gray-500" v-html="license.content" />
                            </TabPanel>
                        </TabPanels>
                    </TabGroup>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { StarIcon } from '@heroicons/vue/solid'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/vue'

let product;
// const product = {
//     name: 'Application UI Icon Pack',
//     version: { name: '1.0', date: 'June 5, 2021', datetime: '2021-06-05' },
//     price: '$220',
//     description:
//         'The Application UI Icon Pack comes with over 200 icons in 3 styles: outline, filled, and branded. This playful icon pack is tailored for complex application user interfaces with a friendly and legible look.',
//     highlights: [
//         '200+ SVG icons in 3 unique styles',
//         'Compatible with Figma, Sketch, and Adobe XD',
//         'Drawn on 24 x 24 pixel grid',
//     ],
//     imageSrc: 'https://tailwindui.com/img/ecommerce-images/product-page-05-product-01.jpg',
//     imageAlt: 'Sample of 30 icons with friendly and fun details in outline, filled, and brand color styles.',
// }
const reviews = {
    average: 4,
    featured: [
        {
            id: 1,
            rating: 5,
            content: `
        <p>Polecam ten produkt!</p>
      `,
            date: 'July 16, 2021',
            datetime: '2021-07-16',
            author: 'Anna Kowalska',
            avatarSrc:
                'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
        },
        {
            id: 2,
            rating: 5,
            content: `
        <p>Produkt wysokiej jakości.</p>
      `,
            date: 'July 12, 2021',
            datetime: '2021-07-12',
            author: 'Tomasz Kowalski',
            avatarSrc:
                'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
        },
        // More reviews...
    ],
}
const faqs = [
    {
        question: 'Masz pytania odnośnie produktu?',
        answer:
            'Skontaktuj się z naszą infolinią.',
    },
    // {
    //     question: 'Can I use the icons at different sizes?',
    //     answer:
    //         "Yes. The icons are drawn on a 24 x 24 pixel grid, but the icons can be scaled to different sizes as needed. We don't recommend going smaller than 20 x 20 or larger than 64 x 64 to retain legibility and visual balance.",
    // },
    // More FAQs...
]
const license = {
    href: '#',
    summary:
        'Dokładamy wszelkich starań aby ceny prezentowane na stronie były aktualne. Jednak ze względu na opóźnienie aktualizacji cen, podana cena może się różnić od ceny w sklepie.',
    content: `
    <h4>Ceny i stan towarów</h4>

<!--    <p>For personal and professional use. You cannot resell or redistribute these icons in their original or modified state.</p>-->

<!--    <ul role="list">-->
<!--    <li>You\'re allowed to use the icons in unlimited projects.</li>-->
<!--    <li>Attribution is not required to use the icons.</li>-->
<!--    </ul>-->

<!--    <h4>What you can do with it</h4>-->

<!--    <ul role="list">-->
<!--    <li>Use them freely in your personal and professional work.</li>-->
<!--    <li>Make them your own. Change the colors to suit your project or brand.</li>-->
<!--    </ul>-->

<!--    <h4>What you can\'t do with it</h4>-->

<!--    <ul role="list">-->
<!--    <li>Don\'t be greedy. Selling or distributing these icons in their original or modified state is prohibited.</li>-->
<!--    <li>Don\'t be evil. These icons cannot be used on websites or applications that promote illegal or immoral beliefs or activities.</li>-->
<!--    </ul>-->
  `,
}

export default {
    name: "ProductPage",
    props: ['id'],
    components:{
        StarIcon,
        Tab,
        TabGroup,
        TabList,
        TabPanel,
        TabPanels
    },

    data: () => ({
        product: [],
        reviews,
        faqs,
        license,
    //     depId: null,
    //     name: null,
    //     address: null,
    //     phone: null,
    //     description: null,
    //     offer: null,
    //     localization: null,
    //     www: null,
    //     logo_src: null,
    //     tags: null,
    //     departments: []
    }),
    created: function () {
        console.log(this.id);
        this.getProductData(this.id);
        // if (this.id) {
        //     this.getProductData(this.id);
        // }
    },
    methods: {
        async getProductData(id) {
            await fetch(`https://dc1.cloudpanel.pl/api/uchowanca/product/${id}`)
                .then(response => response.json())
                .then(result => {
                    this.product = result.product;
                    console.log(result.product);

                });
        },
    }
}

</script>

<style scoped>

</style>
